export default "__VITE_ASSET__DSIleMGS__"